import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Error404 from '../components/errorHandlers/Error404.vue';
import frequencyModel from './frequencyModel';
import store from "@/store/index.js";
Vue.use(VueRouter);

const lettersAtoZ = [...Array(26)]
  .map((_, y) => String.fromCharCode(y + 65).toLowerCase())
  .concat(['all']);
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/artist/:id',
    name: 'Artist',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ArtistSingle.vue')
  },
  {
    path: '/guest/:id',
    name: 'Guest',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ArtistSingle.vue')
  },
  {
    path: '/show/:id',
    name: 'Show',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/EpisodeSingle.vue')
  },
  {
    path: '/serie/:id',
    name: 'Serie',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/SerieSingle.vue')
  },
  {
    path: '/podcasts/:id',
    name: 'Podcasts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ShowSingle.vue')
  },
  {
    path: '/artists',
    name: 'Artists',
    redirect: () => {
      return { name: 'Residents' };
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "artists" */ '../views/Artists.vue'),
    children: [
      {
        path: '/artists/residents',
        name: 'Residents',
        component: () =>
          import(/* webpackChunkName: "artistsarchive" */ '../views/ArtistArchive.vue'),
        meta: { artistType: 'Resident' },
        children: [
          {
            path: ':id',
            name: 'ResidentsId',
            component: () =>
              import(/* webpackChunkName: "artistsarchive" */ '../views/ArtistArchive.vue'),
            meta: { artistType: 'Resident' },
            beforeEnter: (to, from, next) => {
              const isLetterValid = lettersAtoZ.some(e => e == to.params.id);
              if (!isLetterValid) next({ name: 'Residents' });
              else next();
            },
            children: [
              {
                path: ':frequency',
                name: 'ResidentsFrequency',
                component: () =>
                  import(/* webpackChunkName: "ArtistArchive" */ '../views/ArtistArchive.vue'),
                meta: { artistType: 'Resident' },
                beforeEnter: (to, from, next) => {
                  const isFrequencyValueValid = frequencyModel.some(
                    e => e.path == to.params.frequency
                  );
                  if (!isFrequencyValueValid) next({ name: 'Residents' });
                  else next();
                }
              }
            ]
          }
        ]
      },
      {
        path: '/artists/guests',
        name: 'Guests',
        component: () =>
          import(/* webpackChunkName: "artistsarchive" */ '../views/ArtistArchive.vue'),
        meta: { artistType: 'Guest' },
        children: [
          {
            path: ':id',
            name: 'GuestsId',
            component: () =>
              import(/* webpackChunkName: "artistsarchive" */ '../views/ArtistArchive.vue'),
            meta: { artistType: 'Guest' },
            beforeEnter: (to, from, next) => {
              const isLetterValid = lettersAtoZ.some(e => e == to.params.id);
              if (!isLetterValid) next({ name: 'Guests' });
              else next();
            }
          }
        ]
      }
    ]
  },
  {
    path: '/archive',
    name: 'Archive',
    redirect: () => {
      return { name: 'Latest' };
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "archive" */ '../views/Archive.vue'),
    children: [
      {
        path: '/archive/latest',
        name: 'Latest',
        component: () =>
          import(/* webpackChunkName: "archivelatest" */ '../views/ArchiveLatest.vue')
      },
      {
        path: '/archive/series',
        name: 'SeriesAll',
        component: () =>
          import(/* webpackChunkName: "archiveseries" */ '../views/ArchiveSeries.vue'),
        children: [
          {
            path: '/archive/series/:id',
            name: 'SeriesId',
            component: () =>
              import(/* webpackChunkName: "archiveseries" */ '../views/ArchiveSeries.vue'),
            beforeEnter: (to, from, next) => {
              const isLetterValid = lettersAtoZ.some(e => e == to.params.id);
              if (!isLetterValid) next({ name: 'SeriesAll' });
              else next();
            }
          }
        ]
      },
      {
        path: '/archive/shows',
        name: 'ShowsAll',
        component: () => import(/* webpackChunkName: "archiveshows" */ '../views/ArchiveShows.vue'),
        children: [
          {
            path: '/archive/shows/:id',
            name: 'ShowsId',
            component: () =>
              import(/* webpackChunkName: "archiveshows" */ '../views/ArchiveShows.vue'),
            beforeEnter: (to, from, next) => {
              const isLetterValid = lettersAtoZ.some(e => e == to.params.id);
              if (!isLetterValid) next({ name: 'ShowsAll' });
              else next();
            }
          }
        ]
      }
    ]
  },
  {
    path: '/discover',
    name: 'discover',
      redirect: () => {
          return { name: 'discover-genres' };
      },
    component: () => import(/* webpackChunkName: "discover" */ '../views/Discover.vue'),
    children: [
      {
        path: '/discover/location',
        name:'discover-location',
        // redirect: { name: 'location-id-residents', params: {id: 'Athens'} },
        component: () => import(/* webpackChunkName: "location" */ '../views/Location.vue'),
        children: [
              {
                path: '/discover/location/:id/episodes',
                name:'location-id-episodes',
                component: () => import(/* webpackChunkName: "location" */ '../views/LocationEpisodes.vue')
              },
              {
                path: '/discover/location/:id/residents',
                name:'location-id-residents',
                component: () => import(/* webpackChunkName: "location" */ '../views/LocationArtists.vue'),
                meta: { artistType: 'Resident' }
              },
              {
                path: '/discover/location/:id/guests',
                name:'location-id-guests',
                component: () => import(/* webpackChunkName: "location" */ '../views/LocationArtists.vue'),
                meta: { artistType: 'Guest' }
              },
              {
                path: '/discover/location/:id/shows',
                name:'location-id-shows',
                component: () => import(/* webpackChunkName: "location" */ '../views/LocationShows.vue')
              },
        ]
      },
      {
        path: '/discover/genres',
        name: 'discover-genres',
          beforeEnter: async (to, from, next) => {
              await store.dispatch('setGenresState');
              const genresState = store.getters.getGenresState;
              if (!genresState) next({ path: '/discover/location' });
              else next();
          },
        component: () => import(/* webpackChunkName: "discovergenres" */ '../views/DiscoverGenres.vue'),
      }
    ]
  },
  {
    path: '/schedule/',
    name: 'Schedule',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Schedule.vue')
  },
  {
    path: '/about/',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/videos/',
    name: 'VideosArchive',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "VideoSingle" */ '../views/VideoSingle.vue'),
    children: [
      {
        path: '/videos/:id/',
        component: () => import(/* webpackChunkName: "VideoSingle" */ '../views/VideoSingle.vue')
      }
    ]
  },
    {
        path: '/terms-of-use',
        name: 'TermsOfUse',
        component: () => import(/* webpackChunkName: "legal" */ '../views/Legal/TermsOfUse.vue'),

    },
    {
        path: '/privacy-notice',
        name: 'PrivacyNotice',
        component: () => import(/* webpackChunkName: "legal" */ '../views/Legal/PrivacyNotice.vue'),
    },
  {
    path: '*',
    component: Error404
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    return new Promise(resolve =>
      this.app.$once('trigger-scroll', () => {
        if (savedPosition) {
          return resolve(savedPosition);
        }
        return resolve({ x: 0, y: 0 });
      })
    );
  },

  api: process.env.VUE_APP_PUBLIC_API,
  imagePath: process.env.VUE_APP_IMAGE_PATH
});

/**
 * check host name "movement.radio" exists at the location href before vue mounts
 * and then assign new host name "stegi.radio" to current url
 */
router.beforeEach((to, from, next) => {
  const newBaseUrl = 'https://stegi.radio';
  const oldHost = 'movement.radio';
  const windowLocation = new URL(window.location);
  if (windowLocation.host === oldHost) {
    const targetUrl = new URL(to.fullPath, newBaseUrl);
    window.location.replace(targetUrl.href);
  } else {
    next()
  }
});

router.afterEach((to, from) => {
  if (to.name === 'discover-genres' && Object.keys(to.query).length === 0) {
    router.replace({name: 'discover-genres', query: { q: 'genres' }}).then(() => {}).catch(() => {});
  }
});

export default router;
